/**
 * Extends the BaseStore for managing BusinessFunctions.
 */

import BaseStore from '@legacy-src/Datastores/BaseStore';
import { BusinessFunctionInterface } from '@sah/Classes/BusinessFunction';
import BusinessFunctionItemsStore from '@sah/Legacy/Datastores/BusinessFunctionItems';

class BusinessFunctionsStore extends BaseStore<BusinessFunctionInterface> {

    /**
     * This resource will usually have business_function_items that we can patch
     * into the BusinessFunctionItemsStore.
     */
    update(record: BusinessFunctionInterface) {
        // extract the business_function_items
        let business_function_items = record.business_function_items;

        // If the record has business_function_items, patch them into the BusinessFunctionItemsStore
        if (business_function_items && business_function_items.length > 0) {
            BusinessFunctionItemsStore.patch(business_function_items);
        }

        // and remove them from the record to avoid circular references
        record.business_function_items = [];

        // then continue on with the base update
        super.update(record);
    }

    /**
     * Same as above but for storing new items
     */
    store(item: BusinessFunctionInterface) {
        // extract the business_function_items
        let business_function_items = item.business_function_items;

        // If the item has business_function_items, store them in the BusinessFunctionItemsStore
        if (business_function_items && business_function_items.length > 0) {
            BusinessFunctionItemsStore.patch(business_function_items);
        }

        // and remove them from the item to avoid circular references
        item.business_function_items = [];

        // then continue on with the base store
        super.store(item);
    }

}

export default new BusinessFunctionsStore();
